/**
 * Visual clones used for exit animations (popped screens, dismissed sheets,
 * removed elements with a transition) must stay invisible to the renderer,
 * which looks elements up by `data-sb-id`. Stripping that attribute, however,
 * also strips the stylesheet's positioning rules keyed on it, which made a
 * clone's content collapse to flow layout mid-transition. Clones therefore
 * carry the id under `data-sb-ghost` instead, and the stylesheet applies its
 * element rules to both attributes.
 */
export const GHOST_ATTR = 'data-sb-ghost';

/** Deep-clone `el` for an exit animation, renaming every element id to a ghost id. */
export function ghostClone(el: HTMLElement): HTMLElement {
  const clone = el.cloneNode(true) as HTMLElement;
  const rename = (node: Element): void => {
    const id = node.getAttribute('data-sb-id');
    if (id !== null) {
      node.removeAttribute('data-sb-id');
      node.setAttribute(GHOST_ATTR, id);
    }
  };
  rename(clone);
  for (const node of clone.querySelectorAll('[data-sb-id]')) rename(node);
  return clone;
}
